module.exports = __webpack_public_path__ + "img/match-logo-3.110166d9.png";